import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/integracao/relatorio",

        async list({ pagination, filters }) {
            const url = this.userUrl({
                path: `/${pagination.page}/${pagination.amountPerPage}`
            });
            const query = {
                hook: filters.hook,
                onlyFails: filters.onlyFails
            };

            return await Vue.http.get(url, {
                params: query
            });
        },

        async count({ filters }) {
            const url = this.userUrl({ path: `/paginacao` });
            let query = {
                hook: filters.hook,
                onlyFails: filters.onlyFails
            };

            return await Vue.http.get(url, {
                params: query
            });
        }
    },
    base
);
